<script>
  import { ContentLoader } from "vue-content-loader"

  export default {
    name: 'ProfileContentLoader',
    components: { ContentLoader }
  }
</script>

<template>
  <content-loader
    viewBox="0 0 335 435"
    :speed="1"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    
  >
    <path d="M 330 1 H 5 a 4 4 0 0 -4 4 v 425 a 4 4 0 4 4 h 325 a 4 4 0 4 -4 V 5 a 4 4 0 0 -4 -4 z M 5 0 a 5 5 0 0 -5 5 v 425 a 5 5 0 5 5 h 325 a 5 5 0 5 -5 V 5 a 5 5 0 0 -5 -5 H 5 z" /> 
    <path d="M 216 210 h -10 v 10 h 10 v -10 z" /> 
    <path d="M 204 210 h -10 v 10 h 10 v -10 z" /> 
    <path d="M 228.667 210 h -10 v 10 h 10 v -10 z" /> 
    <path d="M 241.333 210 h -10 v 10 h 10 v -10 z" /> 
    <path d="M 249.333 210 H 244 v 10 h 5.333 v -10 z" /> 
    <path d="M 248.998 210.591 l 1.305 2.819 l 0.057 0.122 l 0.133 0.02 l 2.985 0.445 l -2.17 2.207 l -0.089 0.091 l 0.021 0.125 l 0.516 3.108 l -2.634 -1.47 l -0.122 -0.068 l -0.122 0.068 l -2.638 1.473 l 0.493 -3.113 l 0.02 -0.123 l -0.087 -0.09 l -2.147 -2.208 l 2.961 -0.445 l 0.132 -0.02 l 0.057 -0.121 l 1.329 -2.82 z" /> 
    <path d="M 168 183 h 0.25 v -0.25 H 168 v 0.25 z m 0 48 v 0.25 h 0.25 V 231 H 168 z M 13 183.25 h 155 v -0.5 H 13 v 0.5 z m 154.75 -0.25 v 48 h 0.5 v -48 h -0.5 z m 0.25 47.75 H 13 v 0.5 h 155 v -0.5 z" /> 
    <path d="M 168 183 v -0.25 h -0.25 v 0.25 h 0.25 z m 0 48 h -0.25 v 0.25 h 0.25 V 231 z m 0 -47.75 h 155 v -0.5 H 168 v 0.5 z m 155 47.5 H 168 v 0.5 h 155 v -0.5 z m -154.75 0.25 v -48 h -0.5 v 48 h 0.5 z" /> 
    <path d="M 13 344 h 310" /> 
    <rect x="48" y="371" rx="2" ry="2" width="50" height="50" /> 
    <rect x="111" y="371" rx="2" ry="2" width="50" height="50" /> 
    <rect x="174" y="371" rx="2" ry="2" width="50" height="50" /> 
    <rect x="237" y="371" rx="2" ry="2" width="50" height="50" /> 
    <path d="M 223 67 c 0 30.376 -24.624 55 -55 55 s -55 -24.624 -55 -55 s 24.624 -55 55 -55 s 55 24.624 55 55 z" /> 
    <rect x="119" y="132" rx="2" ry="2" width="97" height="18" /> 
    <rect x="39" y="192" rx="2" ry="2" width="103" height="12" /> 
    <rect x="127" y="239" rx="2" ry="2" width="81" height="12" /> 
    <rect x="112" y="306" rx="2" ry="2" width="111" height="12" /> 
    <rect x="116" y="356" rx="2" ry="2" width="103" height="12" /> 
    <rect x="40" y="255" rx="2" ry="2" width="255" height="16" /> 
    <rect x="30" y="274" rx="2" ry="2" width="275" height="16" /> 
    <rect x="102" y="321" rx="2" ry="2" width="131" height="16" /> 
    <rect x="206" y="192" rx="2" ry="2" width="69" height="12" /> 
    <rect x="63" y="208" rx="2" ry="2" width="55" height="12" /> 
    <rect x="265" y="208" rx="2" ry="2" width="24" height="12" /> 
    <rect x="164" y="160" rx="2" ry="2" width="30" height="12" /> 
    <rect x="148" y="160" rx="2" ry="2" width="12" height="12" />
  </content-loader>
</template>
<style scoped>
 
</style>